import React from 'react';
import { GradientBackground } from '../atoms/GradientBackground';
import { BrandSection } from '../molecules/BrandSection';

interface AuthBrandedSideProps {
  /**
   * Variant determines the brand message
   * @default 'login'
   */
  variant?: 'login' | 'invite';
  /**
   * Organization name to display (for invite variant)
   */
  organizationName?: string;
}

/**
 * Organism: Left side branded area
 * Composition of: GradientBackground + BrandSection
 * Clean design without decorative patterns
 */
export const AuthBrandedSide: React.FC<AuthBrandedSideProps> = ({
  variant = 'login',
  organizationName,
}) => {
  return (
    <GradientBackground>
      <BrandSection variant={variant} organizationName={organizationName} />
    </GradientBackground>
  );
};
